import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import useApi from '../../hooks/useApi';
import Profile from '../../components/Profile/Profile';

const ProfileSkeleton = () => (
  <div className="max-w-lg mx-auto p-4 animate-pulse-soft">
    <div className="h-8 w-40 bg-muted rounded-lg mx-auto mb-4" />
    <div className="border border-border rounded-2xl overflow-hidden bg-card">
      <div className="w-full h-64 bg-muted" />
      <div className="p-4 border-b border-border">
        <div className="h-6 w-32 bg-muted rounded-lg" />
      </div>
      <div className="p-4 space-y-3">
        <div className="h-4 w-full bg-muted rounded" />
        <div className="h-4 w-3/4 bg-muted rounded" />
      </div>
    </div>
    <div className="border border-border rounded-2xl overflow-hidden bg-card mt-4">
      <div className="p-4 border-b border-border">
        <div className="h-3 w-16 bg-muted rounded mb-2" />
        <div className="h-5 w-40 bg-muted rounded" />
      </div>
      <div className="p-4">
        <div className="h-4 w-32 bg-muted rounded" />
      </div>
    </div>
  </div>
);

const ShowPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const api = useApi();
  const [child, setChild] = useState<any>(null);
  const [parent, setParent] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadData = async () => {
      try {
        setError(null);
        const response = await api.get(`/api/v1/public/cards/${id}`);
        setChild(response.child);
        setParent(response.parent);
      } catch (err) {
        setError('Profile not found.');
      } finally {
        setLoading(false);
      }
    };
    loadData();
  }, [id]);

  return (
    <div className="min-h-screen bg-background">
      {loading ? (
        <ProfileSkeleton />
      ) : error ? (
        <div className="m-4 p-4 bg-destructive/10 dark:bg-destructive/20 text-destructive border border-destructive/20 rounded-xl text-sm font-medium">{error}</div>
      ) : child && parent ? (
        <Profile child={child} parent={parent} />
      ) : null}
    </div>
  );
};

export default ShowPage;
